import * as React from 'react';
import { Button } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';

const ProjectTypeConfig = {
  'audit_rh/sirh': 'Audit RH / SIRH',
  direction_de_project: 'Direction de projet',
  expertise_et_conseil: 'Expertise & conseil',
  'formation/coaching': 'Formation / coaching',
  gestion_de_projet_it: 'Gestion de projet IT',
  transformation_digitale: 'Transformation digitale',
};

interface IProjectTypeProps {
  isActive: boolean;
  name: string;
  onClick: (id: string) => void;
  src: string;
}

export const ProjectTypeItem: React.SFC<IProjectTypeProps> = (props) => {
  const { isActive, name, onClick, src } = props;
  const label = ProjectTypeConfig[name];
  const opacity = isActive ? 1 : 0.5;
  return (
    <div className='d-flex flex-column align-items-center mr-1'>
      <Button
        className='d-flex justify-content-around bg-primary p-0 border-0'
        style={{ height: '40px', opacity, width: '40px' }}
        onClick={() => onClick(name)}
      >
        <Svg width={24} fill='white' src={src} />
      </Button>
      <span
        className='text-center mt-1'
        style={{ fontSize: '8px', opacity, maxWidth: '45px' }}
      >
        {label}
      </span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Input/ProjectTypeItem.tsx